import {MITTWALD_API, Schemas} from '../middleware/MittwaldApi'
import * as ActionTypes from '../constants/ActionTypes'
import {queryBearerToken} from './UserAuthentication'
import {putFormData} from "./FormData";

// **************************************************************************************************************
const fetchDatabaseData = (bearer) => ({
    [MITTWALD_API]: {
        types: [ActionTypes.DATABASE_REQUEST, ActionTypes.DATABASE_SUCCESS, ActionTypes.DATABASE_FAILURE],
        endpoint: `databasetypes`,
        bearer: bearer,
        schema: Schemas.DATABASE,
        method: 'GET'
    }
})

export const queryDatabaseData = () => (dispatch, getState) => {
    return dispatch(queryBearerToken()).then(() => {
        return dispatch(fetchDatabaseData(getState().token.bearer))
    })
}

const selectDatabaseOption = (databaseSelected) => ({
    type: ActionTypes.SELECT_DATABASE,
    selected: databaseSelected
})

export const queryDatabaseSelect = (databaseSelected) => (dispatch, getState) => {
    dispatch(selectDatabaseOption(databaseSelected))
    return dispatch(putFormData())
}



/** WEBPACK FOOTER **
 ** ./src/actions/DatabaseSelect.js
 **/